import React, { useState } from "react";
import cloneDeep from "lodash.clonedeep";

import { FiltroTipoRelacionamento } from "./FiltroTipoRelacionamento";
import { useAutocompleteOptions } from "./useAutocompleteOptions";
import { AutocompleteMultiselect } from "../autocomplete-multiselect";
import { AutocompletePill } from "./AutocompletePill";

export function RelacionamentoAutocomplete({
  tipoRelacionamentoInicial, //lotacao, cargo, pessoa
  hiddenInputName,
  relacionamentos,
}) {
  const [tipoRelacionamento, setTipoRelacionamento] = useState(tipoRelacionamentoInicial);
  const { autocompleteOptions, onRequestOptions } = useAutocompleteOptions({
    tipoRelacionamento
  });
  const [optionsSelected, setOptionsSelected] = useState(relacionamentos ?? []);

  const disabled = !tipoRelacionamento;

  const removeOption = (option) => {
    const index = optionsSelected.findIndex((op) => op.key == option.key);

    if (index != -1) {
      const copyOptionSelected = cloneDeep(optionsSelected);

      if(copyOptionSelected[index].id) {
        copyOptionSelected[index]._destroy = true;
      } else {
        copyOptionSelected.splice(index, 1);
      }

      setOptionsSelected(copyOptionSelected);
    }
  }

  let placeholder = '';

  if (tipoRelacionamento == 'AlegoShared::Public::Lotacao') {
    placeholder = 'Busque pelo nome da lotação'
  } else if (tipoRelacionamento == 'AlegoShared::Sgu::Usuario') {
    placeholder = 'Busque pelo nome, matricula ou login'
  } else if (tipoRelacionamento == 'AlegoShared::Pessoal::Cargo') {
    placeholder = 'Busque pelo nome do cargo'
  }

  return (
    <div>
      <FiltroTipoRelacionamento value={tipoRelacionamento} onChange={setTipoRelacionamento} />

      {optionsSelected?.map((option, index) => {
        return (
          <React.Fragment key={`hidden-${index}`}>
            <input type='hidden' name={`${hiddenInputName}[][relacionamento_type]`} value={option.relacionamento_type} key={`${index}-relacionamento_type`}/>
            <input type='hidden' name={`${hiddenInputName}[][relacionamento_id]`} value={option.relacionamento_id} key={`${index}-relacionamento_id`}/>
            {!!(option.id && option._destroy) && <input type='hidden' name={`${hiddenInputName}[][_destroy]`} value={true} key={`${index}-destroy`}/>}
            {option.id && <input type='hidden' name={`${hiddenInputName}[][id]`} value={option.id} key={`${index}-id`}/>}
          </React.Fragment>
        )
      })}
      <AutocompleteMultiselect
        onInputChange={onRequestOptions}
        optionsSelected={optionsSelected}
        options={autocompleteOptions}
        onSelect={setOptionsSelected}
        disabled={disabled}
        placeholder={placeholder}
      />
      <div>
        {optionsSelected.map((option) => {
          if (option.error || option._destroy) {
            return;
          }

          return <AutocompletePill option={option} onPress={removeOption} key={option.key} />
        })}
      </div>
    </div>
  );
}